// Load order matters: Bootstrap first, then the design system so V2 tokens
// and base styles win specificity ties against Bootstrap's defaults.
import "./assets/sass/main.scss";
import "./styles/tokens.css";
import "./styles/base.css";
import "./App.css";

import AppHome from "./pages/Home";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AppComing from "./pages/Coming-soon";
import AppHelp from "./pages/Help.js";
import AppSuccess from "./pages/Success.js";
import AppAuth from "./pages/User-auth.js";
import AppFundLearner from "./pages/Fund-learner.js";
import AppHelpLearner from "./pages/Help-learner.js";
import Explore from "./pages/Explore";
import PrivateRoute from "./components/PrivateRoute.js";
import DashboardRouter from "./pages/DashboardRouter";
import Restricted from "./pages/Restricted.js";
import CompleteProfile from "./pages/CompleteProfile.js";
import ChatInterface from "./pages/Chat.js";
import RecommendationsList from "./pages/Recommendation.js";
import ResetPassword from "./pages/ResetPassword.js";
import TermsOfUse from "./pages/termsofuse.js";
import PrivacyPolicy from "./pages/privacypolicy.js";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { Toaster } from "react-hot-toast";
import SponsorStatus from "./pages/sponsor-status.js";
import PaymentVerification from "./pages/payment-verification.js";
import Pricing from "./pages/Pricing.js";
import Moji from "./pages/Moji.js";

function App() {
  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <Router>
        <div className="App">
          <Toaster
            toastOptions={{
              style: {
                background: "white",
              },
              success: {
                style: { color: "green" },
              },
              error: {
                style: { color: "#d32f2f" },
              },
            }}
          />
          <Routes>
            <Route path="/" element={<AppHome />} />
            <Route path="/coming-soon" element={<AppComing />} />
            <Route
              path="/help"
              element={<PrivateRoute component={AppHelp} />}
            />
            <Route path="/success" element={<AppSuccess />} />
            <Route path="/user-auth" element={<AppAuth />} />
            <Route path="/dashboard" element={<DashboardRouter />} />
            <Route path="/explore" element={<Explore />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/moji" element={<Moji />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route
              path="/payment-verification/*"
              element={<PaymentVerification />}
            />
            <Route
              path="/fund-learner"
              element={<PrivateRoute component={AppFundLearner} />}
            />
            <Route
              path="/help-learner"
              element={<AppHelpLearner />}
            />
            <Route
              path="/sponsor-status/*"
              element={<PrivateRoute component={SponsorStatus} />}
            />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/restricted" element={<Restricted />} />
            <Route path="/complete-profile" element={<CompleteProfile />} />
            <Route
              path="/recommendations"
              element={<PrivateRoute component={RecommendationsList} />}
            />
            {/* Public: guests get the pre-account intake chat, signed-in
                learners get their persistent session resumed. */}
            <Route path="/chat" element={<ChatInterface />} />
          </Routes>
        </div>
      </Router>
    </GoogleOAuthProvider>
  );
}

export default App;
